import script from "./section9.vue?vue&type=script&setup=true&lang=js"
export * from "./section9.vue?vue&type=script&setup=true&lang=js"

import "./section9.vue?vue&type=style&index=0&id=c74c8eb8&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c74c8eb8"]])

export default __exports__